// @ts-nocheck
import _ from 'lodash';
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";

import Card, { CardHead } from '../../../ui/Card';
import Button from '../../../ui/Button';
import Alert from '../../../ui/Alert';
import Pill from '../../../ui/Pill';
import Empty from '../../../ui/Empty';
import Table, {
  Th, Td, Tr, TableToolbar,
} from '../../../ui/Table';
import { MailIcon, PlusIcon, CheckCircleIcon, XCircleIcon } from '../../../ui/icons';

const RECOVER_SETUP_DOCS_LINK = 'https://docs.movology.com/docs/setting-up-recover/';

const StatusBadge = ({ status }) => {
  if (status === 'active' || status === 'verified') return <Pill tone="green" dot>{status}</Pill>;
  if (status === 'unverified') return <Pill tone="amber" dot>{status}</Pill>;
  return <Pill tone="gray" dot>{status || 'unknown'}</Pill>;
};

const Row = ({ label, children }) => (
  <div className="flex items-center justify-between gap-3" style={{ borderBottom: '1px dashed var(--mov-line)', paddingBottom: 8 }}>
    <dt className="text-mov-ink-mute mov-mono text-[11px] uppercase tracking-wider">{label}</dt>
    <dd className="m-0">{children}</dd>
  </div>
);

class EmailSettings extends Component {
  render() {
    const em = this.props.store.emailManagement;
    const { activeEmailDomain, activeEmailDomainName } = em;
    const hasDomains = _.size(em.emailDomains) > 0;
    const canVerify = ['active', 'unverified'].includes(activeEmailDomain.status);

    if (!hasDomains) {
      return (
        <Empty
          icon={MailIcon}
          title="No email domain yet"
          sub="Add a domain to start sending recover emails on your behalf."
          actions={(
            <Button variant="primary" icon={PlusIcon} onClick={this.props.handleModalOpen}>
              Add domain
            </Button>
          )}
        />
      );
    }

    return (
      <>
        <Alert tone="info" title="Setup instructions">
          The full guide is at{' '}
          <a href={RECOVER_SETUP_DOCS_LINK} target="_blank" rel="noopener noreferrer" className="text-mov-accent-ink underline">
            docs.movology.com
          </a>.
        </Alert>

        <Card padded className="mt-5 mb-5">
          <CardHead title="Domain details" />
          <dl className="m-0 grid gap-2.5 text-[13px]">
            <Row label="Email domain"><b>{activeEmailDomainName}</b></Row>
            <Row label="Recover plan">{this.props.store.auth.user.status || '—'}</Row>
            <Row label="Domain status">
              <span className="inline-flex items-center gap-2">
                {activeEmailDomain.status === 'active' || activeEmailDomain.status === 'verified'
                  ? <CheckCircleIcon size={14} className="text-mov-accent-ink" />
                  : <XCircleIcon size={14} className="text-mov-danger" />}
                <StatusBadge status={activeEmailDomain.status} />
                {canVerify && (
                  <Button
                    size="sm"
                    variant="primary"
                    loading={em.loading.verifyRecords}
                    onClick={em.verifyRecords}
                  >
                    Verify records
                  </Button>
                )}
              </span>
            </Row>
          </dl>
        </Card>

        <Card padded={false}>
          <TableToolbar title="DNS records" count={_.size(activeEmailDomain.dnsRecords)} />
          <Table>
            <thead>
              <tr>
                <Th>Type</Th>
                <Th>Name</Th>
                <Th>Value</Th>
                <Th align="right">TTL</Th>
              </tr>
            </thead>
            <tbody>
              {_.map(activeEmailDomain.dnsRecords, (r) => (
                <Tr key={`${r.type}-${r.name}-${r.value}`}>
                  <Td mono>{r.type}</Td>
                  <Td mono>{r.name}</Td>
                  <Td mono>{r.value}</Td>
                  <Td mono align="right">{r.TTL}</Td>
                </Tr>
              ))}
            </tbody>
          </Table>
        </Card>
      </>
    );
  }
}

export default inject('store')(observer(EmailSettings));
